import React, { useState } from 'react'
import { Option } from 'types/global'
import FilterMenuSection from './FilterMenuSection'
import FilterMenuPage from './FilterMenuPage'
import OptionList from './OptionList'

interface Props<TValue = string> {
  id: string
  filterLabel: string
  setValue: (value: TValue) => void
  options: Option<TValue>[]
  selectedValue: TValue
}

const MobileFilterSingleSelection = <TValue,>({
  id,
  filterLabel,
  options,
  selectedValue,
  setValue,
}: Props<TValue>) => {
  const selectedValueToLabel = (selectedValue: TValue) =>
    options.find(x => x.value === selectedValue)?.label ?? ''
  const [isSelectionPageOpen, setIsSelectionPageOpen] = useState(false)

  return (
    <>
      <FilterMenuSection
        onClick={() => setIsSelectionPageOpen(true)}
        label={filterLabel}
        labelSelection={selectedValueToLabel(selectedValue)}
      />
      <FilterMenuPage
        controls={{ isOpen: isSelectionPageOpen, setIsOpen: setIsSelectionPageOpen }}
        title={filterLabel}
        withBackBtn
      >
        <OptionList
          name={id}
          options={options}
          selectedValue={selectedValue}
          setSelectedValue={setValue}
        />
      </FilterMenuPage>
    </>
  )
}

export default MobileFilterSingleSelection
